// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3IXNI","selected":"Chip_selected__QIpXy"};